import { useContext } from "react";
import { MainContext } from "../contexts/main";

/**
 * Devuelve la licencia activa (current o inProgress) y si es el mismo plan.
 * @returns { activeLicense, samePlan, currentLicense, inProgressLicense }
 */
export function useActiveLicense() {
  const { mainReducer } = useContext(MainContext);
  const currentLicense = mainReducer.state.currentLicense;
  const inProgressLicense = mainReducer.state.inProgressLicense;
  const samePlan =
    inProgressLicense.id == currentLicense.id &&
    inProgressLicense.periodicity == currentLicense.periodicity &&
    inProgressLicense.licenses == currentLicense.licenses;
  const activeLicense = samePlan ? currentLicense : inProgressLicense;
  return { activeLicense, samePlan, currentLicense, inProgressLicense };
}
